export default "/assets/images/hepa.bd4db2d5f7f0bfe8.webp";